export type CompanyDraft = {
  name: string
  startYear: string
  startMonth: string
  endYear: string
  endMonth: string
}

export type JobHistoryListItem = {
  year: string
  month: string
  desc: string
}

export function createEmptyCompany(): CompanyDraft {
  return {
    name: '',
    startYear: '',
    startMonth: '',
    endYear: '',
    endMonth: ''
  }
}

export function isCompanyEmpty(company: CompanyDraft): boolean {
  return !(
    company.name ||
    company.startYear ||
    company.startMonth ||
    company.endYear ||
    company.endMonth
  )
}

export function buildJobHistories(params: {
  company: CompanyDraft
  isContinuing: boolean
  retirementReason: string
}): JobHistoryListItem[] {
  const { company, isContinuing, retirementReason } = params
  const jobHistories: JobHistoryListItem[] = [
    {
      year: company.startYear,
      month: company.startMonth,
      desc: company.name + '　入社'
    }
  ]
  if (isContinuing) {
    jobHistories.push({
      year: '',
      month: '',
      desc: '現在に至る'
    })
  } else if (company.endYear) {
    jobHistories.push({
      year: company.endYear,
      month: company.endMonth,
      desc: company.name + '　' + retirementReason + '退社'
    })
  }
  return jobHistories
}
